import "@styles/main.scss"

// Temporary dependencies until migrated to other projects in shared theme

// Supports weights 300-800
import "@fontsource-variable/open-sans"
import "@fontsource/poppins/400.css"
import "@fontsource/poppins/500.css"
import "@fontsource/poppins/600.css"
import "@fontsource/poppins/700.css"

import { setGlobalTokens } from "@ehi/styles"

setGlobalTokens()

export const onClientEntry = () => {
    window.addEventListener('load', () => {
        setupRedirectScript();
    });
};

function setupRedirectScript() {
    // Listen to all clicks in the capture phase
    document.addEventListener(
        'click',
        (event) => {
            const target = event.target;
            if (!(target instanceof HTMLElement)) return;
            const anchor = target.closest('a');
            if (!anchor) return;

            const url = new URL(anchor.href, window.location.href);
            if (url.origin !== window.location.origin) return;

            const forceReloadPatterns = [
                '/about-ehealth/careers-benefit/',
            ];

            if (forceReloadPatterns.some((pattern) => url.pathname.startsWith(pattern))) {
                event.preventDefault();
                event.stopPropagation();
                window.location.href = anchor.href;
            }
        },
        true
    );
}